// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DigitalOceanIcon = createSvgIcon(
  <svg width={24} height={24} viewBox="0 0 1567 1562">
    <path
      fill="#0069FF"
      fillRule="evenodd"
      d="M784.5 1562v-302.5c322.4 0 570.3-317.3 447.3-655-44.7-124.3-145.4-224.5-270.2-269C622.4 213 303.8 461.6 303.8 780.8H0C0 270.5 495.7-128.4 1032.4 38.6c234.8 72.3 421.2 259.7 495.7 493.6C1695.8 1068.4 1297 1562 784.5 1562M482.6 960.8h301.9v300.6H482.6zm-232.9 300.6h232.9v231.9H249.7zm-195.6.1v-193h193.8v193z"
    />
  </svg>,
  "DigitalOcean",
);
export default DigitalOceanIcon;
